import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iposcen-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
